import SgiComponent from "./SgiComponent";
import { sgiLogger } from "rt-sd-common";
import { assignProps, assignArrayStr } from "rt-sd-common";
import { getFunctionByKey } from "./SgiCommon";

export default class SgiCtlComponent extends SgiComponent {

    constructor(props) {
        super(props);
    }

    _maker() {
        super._maker();

        let { parentModule, moduleDesc, objFct, type } = this.props;
        let { _props, _class, _style } = this.state;

        // 属性和类名合并
        assignProps(_props, _props);
        assignArrayStr(_class, _class);

        /**************** 转换公共属性 ****************/

        /**************** 控件自身属性 ****************/
        this.__AddAttribute();
        /**************** 绑定事件 ****************/
        this.__bindEvent();

    }

	/**
     * 渲染前处理，包括自定义样式等
     * 初步设计为渲染前的通用处理，例如自定义样式等
     */
    _renderBeforeReturn() {
        const { parentModule, moduleDesc, objFct, type } = this.props;
        let { _props, _class, _style } = this.state;
        let { functions } = this.data;

        // 自定义样式处理
        // const getCstmStyle = functions.cstmStyle;
        const getCstmStyle = getFunctionByKey(this, "cstmStyle");
        let cstmStyle = {};
        if (getCstmStyle) {
            try {
                cstmStyle = getCstmStyle(this, objFct) || {};
            } catch (error) {
                sgiLogger.error(error);
            }
        }
        Object.assign(_style, cstmStyle);

        // className
        _props.className = _class.join(" ");
        _props.style = _style || {};
    }

    __AddAttribute() { }
    __bindEvent() { }


    setHidden(value) {
        let _class = this.state._class;
        if (value && _class.indexOf("sgi-hidden") < 0) {
            _class.push("sgi-hidden");
        } else if (!value && _class.indexOf("sgi-hidden") > -1) {
            _class.splice(_class.indexOf("sgi-hidden"), 1);
        }
        this.setState({ _class });
    }

    setDisabled(value) {
        let _props = this.state._props;
        if (_props.disabled === value) return;

        _props.disabled = value;
        this.setState({ _props });
    }

    setValue(value) {
        if (value === this.state._props.value) return;
        this.state._props.value = value;
        this.setState({});
    }

    getValue() {
        return this.state._props.value;
    }

}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiBaseComp/SgiCtlComponent.js